import translations from '~~/i18n/locales/es-ES.json'

function getNested<T = any, R = any>(obj: T, path: string): R | undefined {
  return path
    .split('.')
    .reduce((o: any, p: string) => (o ? o[p] : undefined), obj)
}

export default (
  key: string,
  params?: Record<string, any> | any,
  ...rest: any[]
): string => {
  const value = getNested(translations, key)
  if (typeof value !== 'string') return key

  let result = value

  if (params && typeof params === 'object' && !Array.isArray(params)) {
    Object.entries(params).forEach(([k, v]) => {
      const regex = new RegExp(`\\{\\s*${k}\\s*\\}`, 'g')
      result = result.replace(regex, String(v))
    })
  } else if (params !== undefined) {
    ;[params, ...rest].forEach((arg, idx) => {
      const regex = new RegExp(`\\{\\s*${idx}\\s*\\}`, 'g')
      result = result.replace(regex, String(arg))
    })
  }

  // Reemplaza el valor de n con el valor de rentUnit.additionalBeds
  // si params es un número
  if (typeof params === 'number') {
    const regex = new RegExp(`\\{\\s*n\\s*\\}`, 'g')
    result = result.replace(regex, String(params))
  }

  // Aplica la lógica de plural y singular
  if (result.includes('|')) {
    const pluralParts = result.split('|').map(part => part.trim())
    let n: number | undefined

    if (params && typeof params === 'object' && !Array.isArray(params)) {
      n = params.n ?? params[0]
    } else if (params !== undefined) {
      n = Number(params)
    }

    if (typeof n === 'number') {
      const pr = new Intl.PluralRules('es-ES')
      const pluralCategory = pr.select(n)

      const pluralOrder = ['one', 'other']
      const pluralIndex = pluralOrder.indexOf(pluralCategory)

      result = pluralParts[pluralIndex] ?? pluralParts[0]
    }
  }

  return result
}
